import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { People as PeopleIcon } from '@mui/icons-material';
import Avatar from 'react-avatar';
import { Text, Theme, CardBlock } from '@simplybenefits/sb-ui-library';
import * as dates from '@simplybenefits/sb-dates';
import { styled } from '@mui/system';

const StyledCardBlockBottom = styled('div')(({ theme }) => ({
    display: 'flex',
    height: 'auto',
    minHeight: '20px',
    paddingTop: '5px',
    width: '100%',
    [theme.breakpoints.down('500')]: {
        justifyContent: 'space-between'
    }
}));

const StyledCardBlockLeft = styled('div')(({ theme }) => ({
    display: 'flex',
    height: '100%',
    lineHeight: '30px',
    textAlign: 'left',
    verticalAlign: 'middle',
    width: '70%',
    [theme.breakpoints.down('500')]: {
        width: 'unset'
    }
}));

const StyledCardBlockRight = styled('div')(({ theme }) => ({
    display: 'inline',
    height: '100%',
    lineHeight: '30px',
    textAlign: 'right',
    verticalAlign: 'middle',
    width: '30%',
    [theme.breakpoints.down('500')]: {
        width: '100%'
    }
}));

const StyledCardBlockTop = styled('div')(({ theme }) => ({
    borderBottom: `1px solid ${ Theme.colors.lightGrey }`,
    display: 'flex',
    height: 'auto',
    minHeight: '65px',
    width: '100%',
    [theme.breakpoints.down('500')]: {
        flexWrap: 'wrap'
    }
}));

const statusMap = {
    0: 'In Progress',
    1: 'Active',
    2: 'Disabled',
    3: 'Under Revisions',
    9: 'Cancelled'
};

class AccountCard extends PureComponent {
    render() {
        const { account, id, testid } = this.props;
        const styles = {
            cardBlockAvatar: {
                display: 'inline',
                height: '100%',
                paddingRight: '20px',
                width: '60px'
            },
            cardBlockLeftBody: {
                display: 'inline',
                height: '100%'
            }
        };

        return (
            <CardBlock
                onClick={this.props.onClick || null}
            >
                <StyledCardBlockTop
                    id={id || testid}
                >
                    <StyledCardBlockLeft>
                        <div style={styles.cardBlockAvatar}>
                            <Avatar
                                name={account.company}
                                size="50"
                                textSizeRatio={2.2}
                                round={true}
                                fgColor={Theme.colors.skyBlue}
                                color={Theme.colors.lightBlue}
                            />
                        </div>

                        <div style={styles.cardBlockLeftBody}>
                            <Text
                                large
                                display="block"
                            >
                                {account.groupNum ? `${ account.company } (${ account.groupNum })` : account.company }
                            </Text>

                            <Text
                                medium
                                display="inline"
                            >
                                {account.contactEmail}
                            </Text>
                        </div>
                    </StyledCardBlockLeft>

                    <StyledCardBlockRight
                        style={{
                            color: Number(account.state) === 9 ? Theme.colors.skyBlue : Theme.colors.darkGrey
                        }}
                    >
                        <Text
                            color={ account.status === 1 ? Theme.colors.brandGreen : (account.status === 2 || account.status === 9) ? Theme.colors.red : Theme.colors.darkGrey }
                            align="right"
                            mediumLarge
                            display="block"
                        >
                            {statusMap[account.status]}
                        </Text>

                        <Text
                            color={Theme.colors.darkGrey}
                            align="right"
                            small
                            display="block"
                        >
                            Advisor: { account.advisor }
                        </Text>
                    </StyledCardBlockRight>
                </StyledCardBlockTop>

                <StyledCardBlockBottom
                    style={{
                        color: Theme.colors.darkGrey
                    }}
                >
                    <StyledCardBlockLeft>
                        <Text
                            color={Theme.colors.darkGrey}
                            medium
                            display="block"
                        >
                            <PeopleIcon />{account.numUsers}
                        </Text>
                    </StyledCardBlockLeft>

                    <StyledCardBlockRight
                        style={{
                            color: Theme.colors.darkGrey
                        }}
                    >
                        <Text
                            color={Theme.colors.darkGrey}
                            tiny
                            display="inline"
                        >
                            UPDATED:&nbsp;{dates.getLocalDisplay(account.dateUpdated, 'lll')}
                        </Text>
                    </StyledCardBlockRight>
                </StyledCardBlockBottom>
            </CardBlock>
        );
    }
}

export default (connect()(AccountCard));